export enum Permission {
  // SUB_ACCOUNTS
  SUBACCOUNT_ADMIN = 'subaccount_admin',
  SUBACCOUNT_ADMIN_ANY = 'subaccount_admin_any',
  SUBACCOUNT_READ = 'subaccount_read',
  SUBACCOUNT_READ_ANY = 'subaccount_read_any',

  // ACCOUNTS
  ACCOUNT_ADMIN = 'account_admin',
  ACCOUNT_ADMIN_ANY = 'account_admin_any',
  ACCOUNT_READ = 'account_read',
  ACCOUNT_READ_ANY = 'account_read_any',

  // BOTS
  BOT_ADMIN = 'bot_admin',
  BOT_ADMIN_ANY = 'bot_admin_any',
  BOT_READ = 'bot_read',
  BOT_READ_ANY = 'bot_read_any',
  BOT_EDIT = 'bot_edit',
  BOT_EDIT_ANY = 'bot_edit_any',
  BOT_CREATE = 'bot_create',
  BOT_CREATE_ANY = 'bot_create_any',
  BOT_DELETE = 'bot_delete',
  BOT_DELETE_ANY = 'bot_delete_any',

  // USERS
  USER_ADMIN = 'user_admin',
  USER_ADMIN_ANY = 'user_admin_any',
  USER_READ = 'user_read',
  USER_READ_ANY = 'user_read_any',
  USER_EDIT = 'user_edit',
  USER_EDIT_ANY = 'user_edit_any',
  USER_CREATE = 'user_create',
  USER_CREATE_ANY = 'user_create_any',
  USER_DELETE = 'user_delete',
  USER_DELETE_ANY = 'user_delete_any',

  // SERVICES
  SERVICE_ADMIN = 'service_admin',
  SERVICE_ADMIN_ANY = 'service_admin_any',

  // INTENTS
  INTENT_ADMIN = 'intent_admin',
  INTENT_ADMIN_ANY = 'intent_admin_any',

  // BOT TEMPLATES
  BOT_TEMPLATE_ADMIN = 'bot_template_admin',
  BOT_TEMPLATE_ADMIN_ANY = 'bot_template_admin_any',

  // INTENT TEMPLATES
  INTENT_TEMPLATE_ADMIN = 'intent_template_admin',
  INTENT_TEMPLATE_ADMIN_ANY = 'intent_template_admin_any',
}

export const SETTINGS_PERMISSIONS = [
  Permission.BOT_ADMIN,
  Permission.BOT_ADMIN_ANY,
  Permission.BOT_EDIT,
  Permission.BOT_EDIT_ANY,
  Permission.BOT_CREATE,
  Permission.BOT_CREATE_ANY,
  Permission.BOT_DELETE,
  Permission.BOT_DELETE_ANY,

  Permission.USER_ADMIN,
  Permission.USER_ADMIN_ANY,
  Permission.USER_EDIT,
  Permission.USER_EDIT_ANY,
  Permission.USER_CREATE,
  Permission.USER_CREATE_ANY,
  Permission.USER_DELETE,
  Permission.USER_DELETE_ANY,

  Permission.ACCOUNT_ADMIN,
  Permission.ACCOUNT_ADMIN_ANY,

  Permission.SUBACCOUNT_ADMIN,
  Permission.SUBACCOUNT_ADMIN_ANY,

  Permission.SERVICE_ADMIN,
  Permission.SERVICE_ADMIN_ANY,

  Permission.INTENT_ADMIN,
  Permission.INTENT_ADMIN_ANY,

  Permission.BOT_TEMPLATE_ADMIN,
  Permission.BOT_TEMPLATE_ADMIN_ANY,
  Permission.INTENT_TEMPLATE_ADMIN,
  Permission.INTENT_TEMPLATE_ADMIN_ANY,
] as const;

export function hasAnyPermission(userPermissions: string[], requiredPermissions: string[]): boolean {
  return requiredPermissions.some(permission => userPermissions.includes(permission));
}

export function hasAllPermissions(userPermissions: string[], requiredPermissions: string[]): boolean {
  return requiredPermissions.every(permission => userPermissions.includes(permission));
}
